<nav class="navbar navbar-expand-lg">
  <div class="container-fluid nav-container">
    <a class="navbar-brand" routerLink="/home">VELOUR</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor03"
      aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarColor03">
      <ul class="navbar-nav mx-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/service" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/artist" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Artists</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact-us" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">Contact</a>
        </li>
      </ul>
      <div class="booking-wrapper">
        <button class="nav-cta" (click)="toggleBookingMenu()">Reserve</button>
        <div class="booking-dropdown" *ngIf="showBookingMenu">
          <p class="booking-label">BOOK WITH</p>
          <a class="booking-option" href="https://www.vagaro.com/veloursalonpaige" target="_blank" (click)="closeBookingMenu()">
            <span class="booking-name">Paige</span>
            <i class="fa-solid fa-arrow-right"></i>
          </a>
          <a class="booking-option" href="https://book.squareup.com/appointments/3vhshh9bgxt5qf/location/LGF8BX08PFET1/services" target="_blank" (click)="closeBookingMenu()">
            <span class="booking-name">Lauren</span>
            <i class="fa-solid fa-arrow-right"></i>
          </a>
          <a class="booking-option" href="https://samanthaguerra.glossgenius.com/" target="_blank" (click)="closeBookingMenu()">
            <span class="booking-name">Samantha</span>
            <i class="fa-solid fa-arrow-right"></i>
          </a>
          <a class="booking-option" href="https://thepolishedparlour.glossgenius.com/" target="_blank" (click)="closeBookingMenu()">
            <span class="booking-name">Hannah</span>
            <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>